import Header from "components/Header";
import Footer from "components/Footer";
import MainTitle from "components/MainTitle";
import QuickDonate from "components/QuickDonate/QuickDonate";
import QuickDonatePopUp from "components/QuickDonate/QuickDonatePopUp";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "redux/rootReducer";
import { Splide, SplideSlide } from "@splidejs/react-splide";
import "@splidejs/react-splide/css";
import { useEffect, useState } from "react";
import { internalProjectsActions } from "redux/actions/internalProjectsActions/internalProjectsActions";
import { Spin } from "antd";
import { useTranslation } from "react-i18next";
import SmsDonationPopup from "components/smsDonation/SmsDonationPopup";
import InternalProjectCard from "./InternalProjectCard";

const InternalProjects = () => {
  const { t } = useTranslation();
  const dispatch: any = useDispatch();

  const { quickDonateStatus } = useSelector(
    (state: RootState) => state.setQuickDonatePopStateReducer
  );

  useEffect(() => {
    dispatch(internalProjectsActions());
  }, [dispatch]);

  const { internalProjectsLoading, internalProjets } = useSelector(
    (state: RootState) => state.internalProjectsReducer
  );

  const [showSmsDonation, setShowSmsDonation] = useState<boolean[]>(
    new Array(internalProjets?.length).fill(false)
  );

  const handleSmsDonationToggle = (index: number) => {
    setShowSmsDonation((prev) => {
      const newState = [...prev];
      newState[index] = !newState[index];
      return newState;
    });
  };

  return (
    <>
      <Header />

      <main className="relative w-full">
        {/* quick donate */}
        <QuickDonate />

        {/* quick donate popup  */}
        {quickDonateStatus && <QuickDonatePopUp />}

        {/* main header section  */}
        <MainTitle title={t("Internal Projects")} />

        <Spin spinning={internalProjectsLoading}>
          <section className="mt-[80px] min-h-[300px] w-full">
            {/* projects card section  */}
            <Splide
              options={{
                direction: `${
                  localStorage.getItem("dir") === "rtl" ? "rtl" : "ltr"
                }`,
                grag: "free",
                arrows: true,
                pagination: false,
                width: "100%",
                autoplay: true,
                rewind: true,
                perMove: 1,
                easing: "ease-out",
                speed: 1000,
                interval: 4000,
                pauseOnHover: false,
                pauseOnFocus: true,
                breakpoints: {
                  8560: { perPage: 4, gap: "20px" },
                  4560: { perPage: 4, gap: "20px" },
                  2560: { perPage: 4, gap: "20px" },
                  1920: { perPage: 3, gap: "20px" },
                  1600: { perPage: 3, gap: "20px" },
                  1200: { perPage: 2, gap: "20px" },
                  800: { perPage: 1, gap: "20px" },
                },
              }}
              className="px-[30px] lg-px-[40px] 2xl:px-[100px] flex flex-wrap items-center justify-center gap-[20px] 2xl:gap-[60px]"
            >
              {internalProjets?.map((project: any, i: number) => {
                return (
                  <SplideSlide
                    key={i}
                    style={{
                      minWidth: "270px",
                    }}
                    className="w-full flex items-center justify-center"
                  >
                    <Spin spinning={internalProjectsLoading}>
                      <InternalProjectCard
                        data={project}
                        showSmsDonation={showSmsDonation[i]}
                        setShowSmsDonation={() => handleSmsDonationToggle(i)}
                      />
                    </Spin>
                  </SplideSlide>
                );
              })}
            </Splide>

            {internalProjets?.map((project: any, i: number) => {
              return (
                <div key={i}>
                  {showSmsDonation[i] && (
                    <SmsDonationPopup
                      project={internalProjets?.at(i)}
                      show={showSmsDonation?.at(i) ?? false}
                      setShow={() => handleSmsDonationToggle(i)}
                    />
                  )}
                </div>
              );
            })}
          </section>
        </Spin>
      </main>

      <Footer />
    </>
  );
};

export default InternalProjects;
